import { percent } from '../utils/format';

interface DeltaProps {
  value: number | null | undefined;
  /** true when a negative number is the good outcome (we are below the market). */
  lowerIsBetter?: boolean;
  suffix?: string;
}

/**
 * A delta pairs its colour with an arrow glyph and a signed number, so the
 * meaning never rests on colour alone.
 */
export function Delta({ value, lowerIsBetter = true, suffix }: DeltaProps) {
  if (value === null || value === undefined) {
    return <span className="delta delta--flat">—</span>;
  }

  const good = lowerIsBetter ? value <= 0 : value >= 0;
  const tone = value === 0 ? 'flat' : good ? 'good' : 'bad';
  const arrow = value === 0 ? '→' : value > 0 ? '↑' : '↓';

  return (
    <span className={`delta delta--${tone}`}>
      <span aria-hidden="true">{arrow}</span>
      {suffix === undefined ? percent(value) : `${value > 0 ? '+' : ''}${value.toFixed(2)}${suffix}`}
    </span>
  );
}
